import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["className", "disabled", "grow", "icon", "marginBetween", "onChange", "size", "tabStyle", "tabs", "theme", "value", "namespace"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useCallback, useMemo } from 'react';
import classNames from 'classnames/bind';
import { sizes } from "./constants";
import { getMethodsForTestId } from "../utils/getMethodsForTestId";
import { isBoolean, isObject } from "../utils/type";
import styles from './Tabs.css';
var cx = classNames.bind(styles);

var Tabs = function Tabs(_ref) {
  var className = _ref.className,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$grow = _ref.grow,
      grow = _ref$grow === void 0 ? false : _ref$grow,
      icon = _ref.icon,
      _ref$marginBetween = _ref.marginBetween,
      marginBetween = _ref$marginBetween === void 0 ? '8px' : _ref$marginBetween,
      onChange = _ref.onChange,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? sizes[1] : _ref$size,
      tabStyle = _ref.tabStyle,
      tabs = _ref.tabs,
      theme = _ref.theme,
      value = _ref.value,
      namespace = _ref.namespace,
      rest = _objectWithoutProperties(_ref, _excluded);

  var _getMethodsForTestId = getMethodsForTestId(namespace, 'tabs'),
      getTestId = _getMethodsForTestId.getTestId;

  var handleChange = useCallback(function (event) {
    var id = parseInt(event.target.dataset.id, 10);

    if (value !== id && onChange) {
      onChange(id);
    }
  }, [onChange, value]);
  var style = useMemo(function () {
    return _objectSpread(_objectSpread({}, tabStyle), {}, {
      marginRight: marginBetween
    });
  }, [marginBetween, tabStyle]);

  var renderTab = function renderTab(tab, i) {
    var content;
    var tabIcon;
    var tabDisabled = disabled;

    if (isObject(tab)) {
      content = tab.title;
      tabIcon = tab.icon || icon;

      if (isBoolean(tab.disabled)) {
        tabDisabled = tab.disabled;
      }
    } else {
      content = tab;
      tabIcon = icon;
    }

    return /*#__PURE__*/React.createElement("button", _extends({
      className: cx('Tab', {
        active: i === value,
        grow: grow
      }, size, theme),
      "data-id": i,
      disabled: tabDisabled,
      key: i,
      onClick: handleChange,
      style: i === tabs.length - 1 ? tabStyle : style,
      type: "button"
    }, getTestId('tab', i.toString())), tabIcon && /*#__PURE__*/React.createElement("div", {
      className: cx('Icon')
    }, tabIcon), content);
  };

  return /*#__PURE__*/React.createElement("div", _extends({
    className: cx('Tabs', className)
  }, getTestId(), rest), tabs.map(renderTab));
};

export default Tabs;